import { useSelector } from 'react-redux';
// Components
import NewsBaseSection from '../../Components/NewsBaseSection';
import NewsQuerySection from '../../Components/NewsQuerySection';
import InternalContainer from '../../Components/InternalContainer';
// Style
import './NewsPage.css';

const NewsPage = () => {
  const { queryNewsView } = useSelector((state) => state.news);
  const { languageInstitution } = useSelector((state) => state.institution);

  if (queryNewsView) {
    return (
      <main className='news-query'>
        <InternalContainer className='no-filters'>
          <NewsQuerySection language={languageInstitution} />
        </InternalContainer>
      </main>
    );
  } else {
    return (
      <main className='news-base'>
        <InternalContainer className='news-base-filters'>
          <NewsBaseSection language={languageInstitution} />
        </InternalContainer>
      </main>
    );
  }
};

export default NewsPage;
